export default "__VITE_ASSET__90a6364f__"